<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2">
<p class="center"><em class="italic">To my son Andries</em></p>
<div class="img_container"><img alt="image" src="images/Img_0002-01.jpg"/></div>
<p class="center">The Irgun emblem.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?0ca4ca95